/* eslint-disable @typescript-eslint/no-explicit-any */
import { Origin } from "@/constants/share";
import useShare from "@/sections/Share/useShare";
import { saveShare, saveShareForMeeting } from "@/services/share";
import useLoginStore from "@/store/login.store";
import summaryCommonStore from "@/store/summaryCommon.store";
import summarySrcStore from "@/store/summarySrc.store";
import disablePageScaling from "@/utils/disablePageScaling";
import formatOrigin from "@/utils/formatOrigin";
import { recordShare } from "@/utils/share";
import { message } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "../components/ErrorPage";
import PassWord from "../components/PassWord";
import Footer from "./components/Footer";
import MobileShareWrap from "@/sections/MobileShareWrap";

export default function ShareMobile() {
  const { loading, needPassword, viewableOrg, checkPassword, checkNeedPassword, shareType } = useShare();
  const [saving, setSaving] = useState(false);
  const [showFooter, setShowFooter] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();

  disablePageScaling();
  const detailInfo = summarySrcStore((state) => state.detailInfo);
  const audioInfo = summaryCommonStore((state) => state.audioInfo);
  const shareInfo = summaryCommonStore((state) => state.shareInfo);
  const streamId = summaryCommonStore((state) => state.streamId);
  const origin = summaryCommonStore((state) => state.origin);
  const hasLogin = useLoginStore((state) => state.hasLogin);

  const location = useLocation();

  const showPassWordPage = needPassword && !shareInfo;

  const getShareInfo = async (password: string) => {
    const searchParams = new URLSearchParams(location.search);
    const shareId = searchParams.get("shareId");
    const streamId = searchParams.get("streamId");
    const origin = searchParams.get("origin") as Origin;
    const fileTransEnable = searchParams.get("fileTransEnable") || 'true'; // 是否经过二次转写, 默认值为true

    if (password && streamId) {
      summaryCommonStore.getState().setShareInfo({
        streamId,
        shareId: shareId || "",
        password,
        origin,
        fileTransEnable: fileTransEnable === 'true'
      });
      summaryCommonStore.getState().setStreamId(streamId);
      if (hasLogin && formatOrigin(origin) === Origin.MAX_LINK) {
        await recordShare(searchParams.get("shareId")!);
        summaryCommonStore.getState().initStore();
        navigate(`/summary?streamId=${streamId}`, { replace: true });
      }
    }
  };

  const handleToLogin = (needPassword: boolean = true) => {
    const params = {
      redirectUrl: location.pathname + location.search + `${!needPassword ? '&needPassword=false' : ''}`,
      cb: "handleSave",
    };
    const search = new URLSearchParams(params).toString();
    navigate(`/mobileLogin?${search}`);
  };

  const handleFinishEnterPassword = (password: string) => {
    checkPassword(password, getShareInfo);
  };

  useEffect(() => {
    if (!needPassword) {
      getShareInfo("1234");
    }
  }, [needPassword]);

  useEffect(() => {
    summaryCommonStore.getState().setIsMobile(true);
    const searchParams = new URLSearchParams(location.search);
    const origin = searchParams.get("origin") as Origin;
    const cb = searchParams.get("cb");
    summaryCommonStore.getState().setOrigin(origin as Origin);
    if (formatOrigin(origin) === Origin.MAX_LINK && !hasLogin) {
      handleToLogin();
      return;
    }


    if (cb) {
      handleSave();
      searchParams.delete("cb");
    }
    return () => {
      summaryCommonStore.getState().setShareInfo(null);
    };
  }, []);

  useEffect(() => {
    if (detailInfo?.title) {
      document.title = detailInfo.title;
    }
  }, [detailInfo]);

  const handleSave = async () => {
    if (hasLogin) {
      try {
        setSaving(true);
        messageApi.loading("保存中...", 0);
        const shareInfo = summaryCommonStore.getState().shareInfo;
        let newStreamId;
        if (shareInfo?.origin === Origin.MEETING_PLATE) {
          const res = await saveShareForMeeting({
            streamName: `live/${streamId}`
          });
          newStreamId = res.data?.replace('live/', '');
          messageApi.destroy();
          setShowFooter(false);
          summaryCommonStore.getState().initStore();
          navigate(`/home`);
        } else {
          const res = await saveShare({
            streamName: `live/${streamId}`,
            contentStep: "SRC_DOC"
          });
          newStreamId = res.data?.replace('live/', '');
          messageApi.destroy();
          // 清空 store, 防止从分享页保存到详情页时，在详情页接口还没返回时，详情页使用的还是分享页的数据，导致错误判断，
          summaryCommonStore.getState().initStore();
          navigate(`/summary?streamId=${newStreamId}`, { replace: true });
        }

        message.success("已保存至AI会记");
      } catch (error: any) {
        messageApi.destroy();
        message.error("保存分享异常");
      } finally {
        setSaving(false);
      }
    } else {
      handleToLogin(false);
    }
  };

  const isWXBrowser = useMemo(() => {
    const ua = navigator.userAgent.toLowerCase();
    return /MicroMessenger/i.test(ua) && !/wxwork/i.test(ua);
  }, []);

  return (
    <div className={`w-full h-full  ${isWXBrowser ? `wx-browser` : ""}`}>
      {contextHolder}
      {loading || shareType ? (
        <ErrorPage viewableOrg={viewableOrg} loading={loading} shareType={shareType} checkNeedPassword={checkNeedPassword} />
      ) : (
        <>
          {!shareInfo && <div className="w-full h-full bg-#f0f1f3">{showPassWordPage && <PassWord fromsource={origin} onFinished={handleFinishEnterPassword} />}</div>}
          {shareInfo && (
            <>
              <MobileShareWrap />
              {showFooter && <Footer
                onSave={handleSave}
                saving={saving}
                showExportAudio={!!audioInfo?.audioSrc}
              />}
            </>
          )}
        </>
      )}
    </div>
  );
}
